import React, { useEffect, useState } from 'react';

import * as S from './styles';
import { useTab } from 'global/TabContext';
import { useUser } from 'global/UserContext';
import EducationFavoritesNextJS from 'microfrontends/Education/Favorites';

export const EducationFavorites = () => {
  const [activeTab] = useState('education_favorites');
  const { setActiveTabContext } = useTab();
  const { user } = useUser();
  const userId = user?.id;

  useEffect(() => {
    setActiveTabContext(activeTab);
  }, [activeTab, setActiveTabContext]);

  return (
    <S.Wrapper>
      <S.Content>{userId && <EducationFavoritesNextJS userId={userId} />}</S.Content>
    </S.Wrapper>
  );
};
